/**
 *
 * SongTermsSelect
 *
 */
import * as React from 'react';
import styled from 'styled-components/macro';
import { faSignalStream, faFileMusic, faThumbsUp, faCompactDisc, faHouse, faFolderMusic, faSackDollar, faTelevision, faUsersLine } from '@fortawesome/pro-thin-svg-icons';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface Props {
  isCommercial: boolean,
  onChange: (any) => void,
  personalPrice: number,
  commercialPrice: number,
 showPriceAsCredits: boolean,
}

function TermPersonalBenefits() {
    return <>
        <BenefitsContainer>
            <BenefitsTitle>
                YOU WILL GET
            </BenefitsTitle>
            <BenefitItem>
                <FontAwesomeIcon icon={faFileMusic}/>
                Full Song (Mixed)
            </BenefitItem>
        </BenefitsContainer>
        <BenefitsContainer>
            <BenefitsTitle>
                YOU CAN USE IT FOR
            </BenefitsTitle>
            <BenefitList>
                <BenefitItem>
                    <FontAwesomeIcon icon={faSignalStream}/>
                    Limited Streaming
                </BenefitItem>
                <BenefitItem>
                    <FontAwesomeIcon icon={faCompactDisc}/>
                    Demos
                </BenefitItem>
                <BenefitItem>
                    <FontAwesomeIcon icon={faThumbsUp}/>
                    Social Media
                </BenefitItem>
                <BenefitItem>
                    <FontAwesomeIcon icon={faHouse}/>
                    Private Parties
                </BenefitItem>
            </BenefitList>
        </BenefitsContainer>
    </>;
}

function TermCommercialBenefits() {
    return <>
        <BenefitsContainer>
            <BenefitsTitle>
                YOU WILL GET
            </BenefitsTitle>
            <BenefitItem>
                <FontAwesomeIcon icon={faFileMusic}/>
                Full Song (Mixed)
            </BenefitItem>
            <BenefitItem>
                <FontAwesomeIcon icon={faFolderMusic}/>
                Stems (Dry Vocals)
            </BenefitItem>
        </BenefitsContainer>
        <BenefitsContainer>
            <BenefitsTitle>
                YOU CAN USE IT FOR
            </BenefitsTitle>
            <BenefitList>
                <BenefitItem>
                    <FontAwesomeIcon icon={faSignalStream}/>
                    Streaming
                </BenefitItem>
                <BenefitItem>
                    <FontAwesomeIcon icon={faTelevision}/>
                    Sync Licensing
                </BenefitItem>
                <BenefitItem>
                    <FontAwesomeIcon icon={faUsersLine}/>
                    Live Performances
                </BenefitItem>
                <BenefitItem>
                    <FontAwesomeIcon icon={faSackDollar}/>
                    Up to $50,000
                </BenefitItem>
            </BenefitList>
        </BenefitsContainer>
    </>;
}

export function SongTermsSelect(props: Props) {
    const { isCommercial, onChange, personalPrice, commercialPrice, showPriceAsCredits } = props

  return (
    <Div>
        <TermOptionsContainer>
            <TermOptionCard selected={!isCommercial} onClick={() => onChange(false)}>
                <TermHeader>
                    <LicenseTitle>
                        Personal
                    </LicenseTitle>
                    <TermPrice>
                        {showPriceAsCredits ? (personalPrice * 100 + ' credits') : '$' + personalPrice.toFixed(2)}
                    </TermPrice>
                </TermHeader>
                <TermDescription>
                    For sharing on social media and streaming non-commercially
                </TermDescription>
            </TermOptionCard>
            <TermOptionCard selected={isCommercial} onClick={() => onChange(true)}>
                <TermHeader>
                    <LicenseTitle>
                        Commercial
                    </LicenseTitle>
                    <TermPrice>
                        {/* TEMP only show USD for commercial no one has enough credits */}
                        {'$' + commercialPrice.toFixed(2)}
                    </TermPrice>
                </TermHeader>
                <TermDescription>
                    For streaming, sync licensing, and other commercial purposes
                </TermDescription>
            </TermOptionCard>

        </TermOptionsContainer>
        <TermDetailsContainer>
            {isCommercial ? (
                <TermCommercialBenefits/>
            ) : (
                <TermPersonalBenefits/>
            )}
        </TermDetailsContainer>
    </Div>
  );
}

const Div = styled.div`
  
`;
const TermOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
`;

const TermDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
`;

const BenefitsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: flex-start;
  padding: 20px;
  
  
  flex-grow: 1;
  flex-shrink: 1;
`;

const BenefitsTitle = styled.div`
  color: #FFF;

  font-family: Jura;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 10px;
`;

const BenefitList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
`;

const BenefitItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  padding-top: 0px;

  color: #55CDC4;
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  .svg-inline--fa {
    margin-right: 10px;
    font-size: 1.5em;
  }
`;

const TermOptionCard = styled.div<{ selected?: boolean; }>`
  border-radius: 7px;
  border: ${props => props.selected ? '1px solid #7100D6' : '1px solid rgba(245, 225, 255, 0.08)'};
  background: ${props => props.selected ? '#2E0840' : '#180D23'};
  padding: 20px;
  margin-left: 20px;
  transition: all 0.2s ease;
  color: ${props => props.selected ? '#fff' : '#f5e1ff'};
  
  max-width: 280px;
  
  &:hover {
    border: 1px solid #ff74e9;
  }
`;

const TermHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const LicenseTitle = styled.div`
  color: #FFF;

  text-align: center;
  text-overflow: ellipsis;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;    
`;

const TermPrice = styled.div`
  color: #FFF;

  text-align: center;
  font-family: Jura;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const TermDescription = styled.div`
  color: #FFF;

  font-family: Raleway;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
